export class Setting {
  idSetting: number;
  setting: string;
  name: string;
  type: string;
  value: string;
  orphan: boolean;

  constructor(
    idSetting: number,
    setting: string,
    name: string,
    type: string,
    value: string,
    orphan: boolean,
  ) {
    this.idSetting = idSetting;
    this.setting = setting;
    this.name = name;
    this.type = type;
    this.value = value;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): Setting {
    return new Setting(
      raw.idSetting,
      String(raw.setting),
      String(raw.name),
      String(raw.type),
      String(raw.value),
      Boolean(raw.orphan),
    );
  }

  clone(): Setting {
    return new Setting(
      this.idSetting,
      this.setting,
      this.name,
      this.type,
      this.value,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idSetting: this.idSetting,
      setting: this.setting,
      name: this.name,
      type: this.type,
      value: this.value,
      orphan: this.orphan,
    };
  }
}
